module.exports = __webpack_public_path__ + "static/3hr-f98e987189c6c1ba6822f254383a8d9b.svg";